/**
 * NOTA: Debido a que estamos migrando a nordic-pages, este vista sera reemplazada.
 * Si tienes que hacer algun cambio en este archivo es necesario que lo agregues en la siguiente ruta:
 */
import CoreDesktop from '../../../../nordic-pages/vip/ui-components/views/core/core.desktop';

export default CoreDesktop;
